import React from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import { CloseButton, HorizontalStack } from '@ztechapps/webui.util'
import { useContext } from './Context'

export const PopUpContainer = ({ children, show, target }) => {
  const { onCloseMenu } = useContext()

  return (
    <Overlay show={show} target={target} placement="left">
      <Popover id="order-customer-popover-contained" placement={'left'} className="shadow-lg">
        <Popover.Header>
          <HorizontalStack className="justify-content-between">
            <div>Create New</div>
            <CloseButton onClick={onCloseMenu} />
          </HorizontalStack>
        </Popover.Header>
        <Popover.Body>
          <div style={{ width: '20vw' }}>{children}</div>
        </Popover.Body>
      </Popover>
    </Overlay>
  )
}
